module.exports = __webpack_public_path__ + "img/logo.95ee897b.png";